import { LeaveComponent } from "../../components";

export default function LeaveRegistrationDataPage() {
  return <LeaveComponent.LeaveRegistrationDataList />;
}
